
export const SET_CLASS_SELECTED = 'SET_CLASS_SELECTED'
export const SET_CLASSES_STATUS = 'SET_CLASSES_STATUS'
export const SET_HISTORICAL_CLASSES = 'SET_HISTORICAL_CLASSES'
export const SET_LOADING_HISTORICAL_CLASSES = 'SET_LOADING_HISTORICAL_CLASSES'
export const SET_CANCEL_ENROLL_CLASS = 'SET_CANCEL_ENROLL_CLASS'

export const SET_CLASS_ATTENDANCE_GRADES_CLASS = 'SET_CLASS_ATTENDANCE_GRADES_CLASS'
